import Styles from './Sections.module.scss'
import { SectionProps } from './Types'
import { CONTENT_CHANNELS } from '../constants'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { WizardListItemContainer } from 'components/Wizards/WizardsDrawer/WizardsDrawerV3/ListItemContainer/ListItemContainer'
import { Common } from './Common'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { useIsVirtualMarketer } from 'hooks/useIsVirtualMarketer'

export const Content = (props: SectionProps) => {
  const { isMobile } = useResponsiveDesign()
  const isVirtualMarketer = useIsVirtualMarketer()

  const wizardsHeading = 'Content creation wizards'
  const channels = CONTENT_CHANNELS.filter((c) => !isVirtualMarketer || c !== GenerationType.SEOPlanning)

  if (isMobile) {
    return (
      <div className={Styles.commonSectionContainer}>
        <WizardListItemContainer wizards={channels} heading={wizardsHeading} withDoc {...props} />
      </div>
    )
  }

  return <Common channels={channels} heading="What do you want to make?" {...props} />
}
